// extracted by mini-css-extract-plugin
export var articleInfoContainer = "X_cR";
export var articleInfoItem = "X_cS";
export var itemChild = "X_cT";